import { useContext, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

// @mui material imports
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

// Logic
import { UserContext } from 'context/authentication/UserContext'
import { getUserPropertiesWithValues } from './ProfilePage.helpers'

const AccountInformation = (): ReactElement | null => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  if (!user) {
    return null
  }

  const userProperties = getUserPropertiesWithValues(user)
  return (
    <Paper
      sx={{
        padding: 2
      }}
    >
      <Typography variant="p2" mb={1} color="primary.main">
        {t('screens.shared.profile.account_information')}
      </Typography>
      <Stack direction="column" spacing={1}>
        {userProperties.map((property) => (
          <Box key={property.label}>
            <Typography variant="p6" color="primary.main">
              {property.label}
            </Typography>
            <Typography color="primary.main">{property.value}</Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  )
}

export default AccountInformation
